import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPupDrsl } from './pages'

type TIdToPageMapWoofzPpp = Record<PageIdWoofzPupDrsl, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PUP_DRSL: TIdToPageMapWoofzPpp = {
  [PageIdWoofzPupDrsl.DOG_AGE_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/DogAge').then(
        (m) => ({
          default: m.DogAge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/DogAge'),
  },
  [PageIdWoofzPupDrsl.DOG_OWNER_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/questions/DogOwnerQuestion'
      ).then((m) => ({
        default: m.DogOwnerQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/DogOwnerQuestion'),
  },
  [PageIdWoofzPupDrsl.TRAINING_COMMANDS_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/questions/BasicTrainingCommands'
      ).then((m) => ({
        default: m.BasicTrainingCommands,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/questions/BasicTrainingCommands'
      ),
  },
  [PageIdWoofzPupDrsl.URGE_PAGE_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_drsl/pages/urge/UrgePage'),
  },
  [PageIdWoofzPupDrsl.DOG_BREED_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/questions/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/DogBreedQuestion'),
  },
  [PageIdWoofzPupDrsl.FACING_CHALLENGES_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/questions/FacingChallenges'
      ).then((m) => ({
        default: m.FacingChallenges,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/FacingChallenges'),
  },
  [PageIdWoofzPupDrsl.FACING_CHALLENGES_2_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/questions/FacingChallengesVersion2'
      ).then((m) => ({
        default: m.FacingChallengesVersion2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/questions/FacingChallengesVersion2'
      ),
  },
  [PageIdWoofzPupDrsl.BEHAVIOR_FREQUENCY_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/questions/BehaviorFrequency'
      ).then((m) => ({
        default: m.BehaviorFrequency,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/BehaviorFrequency'),
  },
  [PageIdWoofzPupDrsl.URGE_PROGRAM_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/urge/UrgeProgram').then(
        (m) => ({
          default: m.UrgeProgram,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/urge/UrgeProgram'),
  },
  [PageIdWoofzPupDrsl.BEHAVIOR_FEELINGS_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/questions/BehaviorFeelings'
      ).then((m) => ({
        default: m.BehaviorFeelings,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/BehaviorFeelings'),
  },
  [PageIdWoofzPupDrsl.FIX_BEHAVIOR_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/questions/FixDogBehavior'
      ).then((m) => ({
        default: m.FixDogBehavior,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/FixDogBehavior'),
  },
  [PageIdWoofzPupDrsl.URGE_PAGE_4_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/urge/UrgePageVariant4'),
  },
  [PageIdWoofzPupDrsl.COMMANDS_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/DogCommands').then(
        (m) => ({
          default: m.DogCommands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/DogCommands'),
  },
  [PageIdWoofzPupDrsl.PARENT_GOAL_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/GoalQuestion').then(
        (m) => ({
          default: m.GoalQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/GoalQuestion'),
  },
  [PageIdWoofzPupDrsl.TRAINING_PLACE_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/TrainingPlace').then(
        (m) => ({
          default: m.TrainingPlace,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/TrainingPlace'),
  },
  [PageIdWoofzPupDrsl.TRAINING_FREQUENCY_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/TimeQuestion').then(
        (m) => ({
          default: m.TimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/questions/TimeQuestion'),
  },
  [PageIdWoofzPupDrsl.URGE_PAGE_5_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/urge/UrgePageVariant5'),
  },
  [PageIdWoofzPupDrsl.PREPARE_FLOW_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/prepare-flow/PrepareFlowPpp'
      ).then((m) => ({
        default: m.PrepareFlowPpp,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/prepare-flow/PrepareFlowPpp'),
  },
  [PageIdWoofzPupDrsl.EMAIL_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/email/EmailPpp').then((m) => ({
        default: m.EmailPpp,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_drsl/pages/email/EmailPpp'),
  },
  [PageIdWoofzPupDrsl.NEWSLETTER_URGE_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzPupDrsl.LAST_CHANCE_OFFER_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/last-chance-offer/LastChanceOfferPpp'
      ).then((m) => ({
        default: m.LastChanceOfferPpp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/last-chance-offer/LastChanceOfferPpp'
      ),
  },
  [PageIdWoofzPupDrsl.SUBSCRIPTIONS_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.Subscriptions,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzPupDrsl.CHAT_UPSELL_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzPupDrsl.UPSELL_PUP_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_drsl/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_drsl/pages/upsell/Upsell'),
  },
  [PageIdWoofzPupDrsl.UPSELL_FEEDING_GUIDE_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/upsell/FeedingGuideUpsell'
      ).then((m) => ({
        default: m.FeedingGuideUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzPupDrsl.UPSELL_EMOTIONAL_SUPPORT_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/upsell/EmotionalSupportUpsell'
      ),
  },
  [PageIdWoofzPupDrsl.DOWNLOAD_PUP_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_drsl/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_drsl/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzPupDrsl.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
